import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";

const { actions: actionsCopy, profile } = copy;
const { actions: profileCopy } = profile;

export const getProfileSummaryActions = ({
  handleEdit,
  handleChangeEmail,
  handleChangePassword,
}: {
  handleEdit: () => void;
  handleChangeEmail: () => void;
  handleChangePassword: () => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [
    {
      label: actionsCopy.edit,
      handleClick: handleEdit,
      dataTestId: "edit_profile",
    },
    {
      label: profileCopy.changeMail,
      handleClick: handleChangeEmail,
      dataTestId: "edit_mail",
    },
    {
      label: profileCopy.changePassword,
      handleClick: handleChangePassword,
      dataTestId: "edit_password",
    },
  ];

  return actions;
};
